var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-bottom":"60px","height":"auto"}},[_c('div',{staticStyle:{"margin-top":"40px"}},[_c('div',{staticClass:"nav-content"},[(_vm.isNav)?_c('inside-left',{attrs:{"left":_vm.left}}):_vm._e(),_vm._v(" "),_c('inside-right-vue',{attrs:{"right":_vm.right}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28689e44","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inside/solution.vue
// module id = null
// module chunks = 